import React, { useState } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../../utils/with-router-props'

import ShsForm from '../../../utils/shs-form'
import InputElement from '../../../utils/input'
import SearchComplete from '../../../utils/search-complete'
import { formatCurrency } from '../../../utils/formatters'

import { callApi } from '../../../../actions/api'
import { apiResourceEndpoint, routes } from '../../../../constants/routes'

const CreatePayout = ({ dispatch, navigate }) => {
    const [receiptId, setReceiptId] = useState(null)
    const [vendorId, setVendorId] = useState(null)
    const [vendorName, setVendorName] = useState('')
    const [agentId, setAgentId] = useState(null)
    const [agentName, setAgentName] = useState('')

    const submitFX = (formData, formId) => {
        formData.agentId = agentId
        formData.receiptId = receiptId
        formData.vendorId = vendorId
        dispatch(callApi(apiResourceEndpoint('admin/payouts', 'CREATE'), formData, formId))
    }

    const successFX = () => {
        navigate(routes.adminFinancePayoutsIndex)
    }

    const renderReceiptResult = (result) => {
        return (
            <>{result._computed.vendorName} {formatCurrency(result.net, 2, 2)} (Balance {formatCurrency(result.balance, 2, 2)})</>
        )
    }

    const handleSelectReceipt = (result) => {
        setReceiptId(result.id)
        setVendorId(result.vendorId)
        setVendorName(result._computed.vendorName)
    }

    const renderAgentResult = (result) => {
        return (
            <>{result.firstName} {result.lastName}</>
        )
    }

    const handleSelectAgent = (result) => {
        setAgentId(result.id)
        setAgentName(`${result.firstName} ${result.lastName}`)
    }

    return (
        <div>
            <h1>Create Payout</h1>
            <p>Use the form below to create a new payout</p>
            <ShsForm submitFX={submitFX} successFX={successFX}>
                <div className="mb-3">
                    <label>Receipt</label>
                    <SearchComplete
                        placeholder="Search for a Received Commission"
                        searchEndpoint="admin/receipts"
                        extraClass="form-control"
                        renderTemplate={renderReceiptResult}
                        onHandleSelect={handleSelectReceipt}
                        excludeFilter={['balance|0|>']}
                        allowCreation={false} />
                    { receiptId &&
                        <p>Receipt from {vendorName}</p>
                    }
                </div>
                <div className="mb-3">
                    <label>Agent</label>
                    <SearchComplete
                        placeholder="Search for an Agent"
                        searchEndpoint="admin/agents"
                        extraClass="form-control"
                        renderTemplate={renderAgentResult}
                        onHandleSelect={handleSelectAgent}
                        allowCreation={false} />
                    { agentName &&
                        <p>Selected Agent: {agentName}</p>
                    }
                </div>
                <InputElement
                    type="text"
                    label="Amount"
                    id="amount"
                    placeholder="$1,200.00"
                    required />
            </ShsForm>
        </div>
    )
}

export default withRouterProps(connect()(CreatePayout))
